import * as Styled from './styles';
import { Props } from '../interfaces';

function PrimaryButton({ show, onClick, children, type, loading }: Props) {
  return (
    show && (
      <Styled.PrimaryButton
        onClick={onClick}
        variant="primary"
        type={type}
        loading={loading}
        disabled={loading}
      >
        {children}
      </Styled.PrimaryButton>
    )
  );
}

PrimaryButton.defaultProps = {
  type: 'button',
};

export default PrimaryButton;
